(() => {
  const list = document.getElementById('ginkgo-review-list');
  const dialog = document.getElementById('ginkgo-review-dialog');
  const form = document.getElementById('ginkgo-review-form');
  if (!list || !dialog || !form) return;
  const storageKey = 'ginkgo-local-reviews-v1';
  let saved = [];
  try {
    const data = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(data)) saved = data.filter(item => item && typeof item.name === 'string' && typeof item.body === 'string' && item.name.length <= 60 && item.body.length <= 1200 && Number.isInteger(item.rating) && item.rating >= 1 && item.rating <= 5).slice(-20);
  } catch { /* The wall works when browser storage is unavailable. */ }
  const add = item => {
    const row = document.createElement('article');
    row.className = 'ginkgo-review-row ginkgo-review-row--text ginkgo-review-row--local';
    const meta = document.createElement('div');
    meta.className = 'ginkgo-review-meta';
    const name = document.createElement('strong');
    name.textContent = item.name;
    meta.append(name);
    const stars = document.createElement('div');
    stars.className = 'ginkgo-review-stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${item.rating} de 5 estrellas`);
    stars.textContent = '★'.repeat(item.rating) + '☆'.repeat(5 - item.rating);
    const body = document.createElement('p');
    body.textContent = item.body;
    row.append(meta, stars, body);
    list.prepend(row);
  };
  saved.forEach(add);
  document.querySelector('[data-write-review]').addEventListener('click', () => dialog.showModal());
  dialog.querySelector('[data-close-review]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    const item = {name: String(data.get('name') || '').trim().slice(0, 60), body: String(data.get('body') || '').trim().slice(0, 1200), rating: Number(data.get('rating'))};
    if (!item.name || item.body.length < 8 || !Number.isInteger(item.rating) || item.rating < 1 || item.rating > 5) return;
    saved.push(item);
    saved = saved.slice(-20);
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch { /* No remote submission. */ }
    add(item);
    form.reset();
    dialog.close();
    document.querySelector('.ginkgo-review-status').textContent = 'Gracias por compartir tu experiencia.';
  });
})();
